import React, { useState } from "react";
import dynamic from "next/dynamic";
import { HeaderLayout } from "./components/HeaderLayout";
import styled, { createGlobalStyle } from "styled-components";
const HeaderSide = dynamic(() => import("./components/Side"), { ssr: false });
const GlobalStyle = createGlobalStyle `
	body.litb-m-fixscroll {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}
`;
const LitbMHeader = styled.div `
	> div {
		z-index: 3000;
	}
`;
function Header(props) {
    const [shareState, setShareState] = useState({});
    return (React.createElement(LitbMHeader, null,
        React.createElement(GlobalStyle, null),
        React.createElement(HeaderLayout, { language_code: shareState.language_code, total_results: shareState.total_results, onMenuIconClick: shareState.openSidebar, onSearchIconClick: shareState.openSearchModal }),
        React.createElement(HeaderSide, Object.assign({}, props, { onShareStateChange: setShareState }))));
}
export default Header;
